import { render, staticRenderFns } from "./ClientOfflinePayment.vue?vue&type=template&id=1b375848"
import script from "./ClientOfflinePayment.vue?vue&type=script&lang=js"
export * from "./ClientOfflinePayment.vue?vue&type=script&lang=js"
import style0 from "./ClientOfflinePayment.vue?vue&type=style&index=0&id=1b375848&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports